import { render } from "./PanesEditor.vue?vue&type=template&id=5bf34f98&scoped=true"
import script from "./PanesEditor.vue?vue&type=script&lang=js"
export * from "./PanesEditor.vue?vue&type=script&lang=js"

import "./PanesEditor.vue?vue&type=style&index=0&id=5bf34f98&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf34f98"]])

export default __exports__